import React, { useState, useEffect } from "react";
import Loader from "./Loader"; // loader import karo

const Home = () => {
  const [loading, setLoading] = useState(true); // loading state

  useEffect(() => {
    // Simulate delay: 2 seconds tak loading dikhana
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  if (loading) {
    return <Loader />; // agar loading true hai to Loader dikhao
  }

  return <></>;
};

export default Home;
